import r from "./index.es242.js";
const i = r.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, n) => (o) => (o = new URL(o, r.origin), t.protocol === o.protocol && t.host === o.host && (n || t.port === o.port)))(
  new URL(r.origin),
  r.navigator && /(msie|trident)/i.test(r.navigator.userAgent)
) : () => !0;
export {
  i as default
};
//# sourceMappingURL=index.es412.js.map
